'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoVideocamera = function IoVideocamera(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.2 14.5v5.1l8.8-2.7v13.8l-8.8-2.7v5c0 0.4-0.3 0.7-0.7 0.7h-24.8c-0.4 0-0.7-0.3-0.7-0.7v-18.5c0-0.4 0.3-0.7 0.7-0.7h16.3v-3c0-0.3-0.5-0.8-0.8-0.8h-13.8v-3.7h13.9c2.8 0 5.1 2.2 5.1 5v2.5h4.1c0.4 0 0.7 0.3 0.7 0.7z m-8.5 12.1c1.5 0 2.8-1.2 2.8-2.8s-1.3-2.7-2.8-2.7-2.9 1.2-2.9 2.7c0 0.8 0.4 1.5 0.9 2.1h-5.3c0.5-0.6 0.8-1.3 0.8-2.1 0-1.5-1.2-2.8-2.8-2.8s-2.8 1.3-2.8 2.8 1.3 2.8 2.8 2.8h9.3z' })
        )
    );
};

exports.default = IoVideocamera;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/videocamera.js
// module id = 2521
// module chunks = 0